import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ValidatorsBuilderService} from './validators-builder.service';
import {FormWithErrorsDirective} from './form-with-errors.directive';

@NgModule({
  declarations: [FormWithErrorsDirective],
  imports: [CommonModule],
  exports: [FormWithErrorsDirective],
  providers: [ValidatorsBuilderService],
})
export class EparcoursValidatorsModule {}
